import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
  video: { type: "file" | "external"; src: string };
  onClose: () => void;
}

const VideoPlayerModal: React.FC<Props> = ({ video, onClose }) => (
  <div className="fixed inset-0 bg-black/90 flex justify-center items-center z-[100]"
    onClick={(e) => e.target === e.currentTarget && onClose()}>
    <div className="relative w-[95%] max-w-5xl bg-black rounded-2xl overflow-hidden shadow-2xl">
      <button onClick={onClose}
        className="absolute top-4 right-4 z-10 bg-black/60 hover:bg-black text-white rounded-full p-2 transition-all">
        <XMarkIcon className="w-6 h-6" />
      </button>
      {video.type === "file" ? (
        <video src={video.src} controls autoPlay className="w-full max-h-[80vh] object-contain"
          controlsList="nodownload" />
      ) : (
        <iframe src={video.src} className="w-full h-[70vh] md:h-[80vh] border-0"
          allowFullScreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
      )}
    </div>
  </div>
);

export default VideoPlayerModal;
